export const tableFieldOrders = [
  { text: 'langkey.status', value: 'status' },
  { text: 'langkey.order-id', value: 'id' },
  { text: 'langkey.date', value: 'created' },
  { text: 'langkey.delivery-address', value: 'address' },
  { text: 'langkey.note', value: 'note' },
  { text: 'langkey.supplier', value: 'supplier' },
  { value: 'data-table-expand' },
];